import Axios from './APIService';
import { AxiosPromise } from 'axios';

import AccountingOverview from '@/types/AccountingOverview';

const admin = '/admin';

const apiBase = '/accounting';

const AccountingAPI = {

    get(): AxiosPromise<AccountingOverview> {
        return Axios.get<AccountingOverview>(admin + apiBase);
    },

    getRoyaltyReport(): AxiosPromise<string> {
        return Axios.get<string>(admin + '/reports/royalty');
    },

    getManagementReport(): AxiosPromise<string> {
        return Axios.get<string>(admin + '/reports/management');
    }

};

export default AccountingAPI;
